module.exports = __webpack_public_path__ + "img/marker_salut.1b8f32ce.svg";